<template>
  <div><h2>

  </h2>
    <div class="container parentContainer">
      <div class="header">

        <div class="item-1 item" >
          <img src="https://static.wixstatic.com/media/ea94eb_ab751f21eff6434b8aa93d62302bc42d~mv2_d_1796_2088_s_2.png" alt="NMR Events Logo" class="badge-image">
        </div>
      </div>
      <div class="dataFields" style="height: 200px;" >
        <b-form @submit="onSubmit" style="display: flex; flex-direction: column; justify-content: space-evenly">
          <b-form-group >
            <b-form-input id="nickname" v-model.trim="login.nickname" placeholder="Name">

            </b-form-input>
            <b-form-input type="number" id="meetingID" v-model.trim="login.meetingID" placeholder="Session ID">

            </b-form-input>
          </b-form-group>
          <button class="SubmitButton" type="submit" :disabled="!login.meetingID">
            Login
          </button>
<!--          <b-button type="submit" class="SubmitButton" :disabled="!login.meetingID">Login</b-button>-->
        </b-form>
      </div>
      <div>
      </div>
      <div>
      </div>
    </div>
  </div>
</template>

<script>

  import router from '../router'
  import firebase from "../firebase";

  export default {
    name: 'AddBoard',
    data() {
      return {
        login: {
          nickname: '',
          meetingID: '',
          userID: '',
          present: true
        }
      }
    },
    methods: {
      onSubmit: function(evt) {
        evt.preventDefault()
        // get the current logged session number
        let newSessionKey = this.login.meetingID;

        // get a unique user ID returned from firebase  &&  also setup the path to store the User data
        let userFbID = firebase.database.ref('/Session/' + this.login.meetingID + '/Users/').push();
        this.userID = userFbID.key;
        this.login.userID = userFbID.key;
        // Change web page through the router setup
        let postData = {
          name: this.login.nickname,
          meetingID: this.login.meetingID,
          activeUser: false,
          request_control: false,
          uID: userFbID.key,
          present: true
        };



        router.push({
          name: 'RoomList',
          params: {
            nickname: this.login.nickname,
            meetingID: this.login.meetingID,
            userID: this.login.userID,
          }
            // });
        })
        var updates = {};
        updates['/Session/' + this.login.meetingID + '/Users/' + this.userID] = postData;

        this.$store.dispatch('storeSessionDataAction', postData);

        firebase.database.ref().update(updates);
        this.$store.dispatch('addUser', userFbID);


        // setup data to be stored on Firebase



        // storeSessionData: function() {

        // }
      }
    },

  }
</script>

<style>
  .SubmitButton {
    background-color: #376a88;
    color: #eeeeff;
    border: none;
    padding: 0;
    border-radius: 5px;
    outline: none;

  }
  .SubmitButton:focus{
    outline: none;
  }
  .SubmitButton:disabled {
    background-color: rgba(55, 106, 136, 0.3);
  }
  .SubmitButton:hover {
    background-color: rgba(55, 106, 136, 0.3);
  }
  .SubmitButton:active {
    background-color: #64beff;
  }


  .jumbotron {
    padding: 2rem;
  }

  .dataFields {
    display: flex;
    flex-direction: column;
    padding: 7%;
  }

  .parentContainer {
    display: flex;
    justify-content: space-between;
  }

input, textarea {
  background-color: #EEEEEE !important;

}

  ::-webkit-input-placeholder { /* WebKit browsers */
    color:    #EEEEEE;
  }
  :-moz-placeholder { /* Mozilla Firefox 4 to 18 */
    color:    #EEEEEE;
  }
  ::-moz-placeholder { /* Mozilla Firefox 19+ */
    color:    #EEEEEE;
  }
  :-ms-input-placeholder { /* Internet Explorer 10+ */
    color:    #EEEEEE;
  }

  .badge-image{
    max-width: 172px;
    text-align: center;
  }

</style>